import GridModel from '../models/gridmodel';

const GridCollection = Backbone.Collection.extend({
  model: GridModel,
  initialize(collection) {

    this.listenTo(phillips.Events, 'addModel', (model) => {
      this.add(model);
    });

    this.listenTo(phillips.Events, 'editTeamOrder', this.updateCollection);

    if (collection.length === 0 && window.location.pathname.toUpperCase() !== '/AUCTIONMOBILITYREGISTRATION') {
      this.fetch({
        error: (model, response, options) => {
          console.log(model);
          console.log(response);
          console.log(options);
          if (response && response.status && response.status === 401) {
            $('#modalFail').find('p').html('Your session has expired, redirecting to login...');
            $('#myModal').toggleClass('hide', false)
            $('#modalFail').toggleClass('hide', false);
            $('#modalFail').toggleClass('hidden', false);
            setTimeout(() => { window.location.href = `/Account/Login?returnUrl=${window.location.pathname}${window.location.search}` }, 5000);
          } else {
            $('#modalFail').find('p').html('There was an error.  Please contact the administrator.');
            $('#myModal').toggleClass('hide', false)
            $('#modalFail').toggleClass('hide', false);
            $('#modalFail').toggleClass('hidden', false);
          }
        }
      });
    }
  },
  url(params) {
    let urlPage = '';
    switch (window.location.pathname.toUpperCase()) {
      case '/AUCTION':
        urlPage = '/api/Auctions/Get';
        break;
      case '/DEPARTMENT':
        urlPage = '/api/Departments/Get';
        break;
      case '/VIDEO':
        urlPage = '/api/Videos/Get';
        break;
      case '/LOCATION':
        urlPage = '/api/Locations/Get';
        break;
      case '/CAREER':
        urlPage = '/api/Careers/Get';
        break;
      case '/TEAM':
        urlPage = '/api/TeamMembers/Get';
        break;
      case '/AUCTIONMOBILITYAUCTION':
        urlPage = '/api/AuctionMobilityAuctions/GetAuctionMobilityAuctions';
        break;
      case '/AUCTIONMOBILITYREGISTRATION':
        urlPage = `api/AuctionMobilityRegistrations/Get/${params}`;
        break;
      case '/EDITORIAL':
        urlPage = '/api/editorial';
        break;
      case '/MAKER':
        urlPage = '/api/maker';
        break;
      default:
        urlPage = '/api/';
        break;
    }
    return `${phillips.domainURL}${urlPage}`;
  },
  comparator: function (model) {
    if (model.get('displayOrder') !== undefined) {
      return model.get('displayOrder');
    } else if (model.get('sortOrder') !== undefined) {
      return model.get('sortOrder');
    } else if (model.get('lotNumber') !== undefined) {
      return model.get('lotNumber');
    }
  },
  updateCollection() {
    this.fetch({ reset: true });
  }
});

export default GridCollection;
